module.exports = __webpack_public_path__ + "public/adminIcons/whyHost.svg?c66ac65b";